import moment, { Moment } from 'moment';

export const convertTemplatedHrsToDate = (hours: string): Moment => {
  const defaultDate = '2010-01-01';
  return moment(`${defaultDate} ${hours}`);
};